module.exports = __webpack_public_path__ + "static/media/logo.ad3e9472.png";